import React from 'react';
// import {makeStyles} from '@material-ui/core/styles';
import { Link as MDLink } from '@material-ui/core';
import { Link as RTLink} from 'react-router-dom';
export default function RaymanLink(props)
{
    return <MDLink 
    component = {props.to ? RTLink : undefined}
    {...props} />
}